import axios from 'axios'
import {Message} from 'element-ui'
import Cookies from 'js-cookie';
import { getProductionApiBaseUrl } from '@/utils/apiUrl'
function downloadExcel(res) {
  if (!res.data.size) {
    Message.error('请求异常，请重试！');
    return
  }
  // const filename = res.headers['content-disposition'].split('=')[1];
  let filename = sessionStorage.getItem('filename');

  const href = window.URL.createObjectURL(new Blob([res.data]));
  const aNode = document.createElement('a');
  aNode.style.display = 'none';
  aNode.href = href;
  aNode.download = decodeURI(filename);
  document.body.appendChild(aNode);
  aNode.click();
  document.body.removeChild(aNode);
  window.URL.revokeObjectURL(href)
}
// create an axios instance
const download = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "/api" : getProductionApiBaseUrl(),

  responseType: 'blob',
  timeout: 3000000 // request timeout
});
// request拦截器
download.interceptors.request.use(
  config => {
    //设置header
    const PublicKey = Cookies.get('PublicKey');
    const LoginUsersId = Cookies.get('LoginUsersId');
    const LoginUsersToken = Cookies.get('LoginUsersToken');
    if(PublicKey) {
      config.headers['Public-key'] = PublicKey
    } else {
      config.headers['Public-key'] = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDy8oXwkKZRB7AuSpN55qZnUXZzgAQnD1FtiyD-BqI3-U5oJUo8ASPpMZBjl9M1h4HITEO7V6x-Q3ErOe1z7VZFIm6hm2OeMK46vT9wG7TPBeL0NBRM1e0_YSWLStHRUsG4DGgD4w5e0xjnAmzq7xJYrs51AwJz7mpBYNOLV1CR5QIDAQAB'
    }
    if(LoginUsersToken) {
      config.headers['Login-users-token'] = LoginUsersToken
    }
    if(LoginUsersId) {
      config.headers['Login-users-id'] = LoginUsersId
    }
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);
// response interceptor
download.interceptors.response.use(
  response => {
    if (!response.data.size) {
      Message.error('请求异常，请重试！');
      return
    }
    downloadExcel(response);
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 2 * 1000,
      offset: 200
    })
    return Promise.reject(error)
  }
)

export default download



// WEBPACK FOOTER //
// ./src/utils/download.js